import React, { useState } from "react";
import "./ReviewSlider.scss";
import arrow from "../../assets/arrow.svg"


const ReviewSlider = ({ reviews }) => {
    const [current, setCurrent] = useState(0);

    const nextSlide = () => {
        setCurrent((prev) => (prev + 1) % reviews.length);
    };

    const prevSlide = () => {
        setCurrent((prev) =>
            prev === 0 ? reviews.length - 1 : prev - 1
        );
    };

    return (
        <div className="reviewSlider">
            <img className="arrow left" onClick={prevSlide} src={arrow} />

            <div className="reviewCard">
                <div className="reviewCard-review">{reviews[current].review}</div>

                <div className="reviewCard-name">{reviews[current].name}</div>
            </div>

            <img className="arrow right" onClick={nextSlide} src={arrow} />

            <div className="dots">
                {reviews.map((_, index) => (
                    <span
                        key={index}
                        className={current === index ? "dot active" : "dot"}
                        onClick={() => setCurrent(index)}
                    />
                ))}
            </div>
        </div>
    );
};

export default ReviewSlider;
